"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBMISSIONS = exports.AVATARS = void 0;
exports.AVATARS = 'profiles/avatars';
exports.SUBMISSIONS = 'submissions';
//# sourceMappingURL=schema.js.map